// extracted by mini-css-extract-plugin
module.exports = {"popover":"PopoverSharedStyle_popover__3QNIC","active":"PopoverSharedStyle_active__3z7qu","backdrop":"PopoverSharedStyle_backdrop__2QqDP"};